import { Mesh, type Object3D } from 'three'
import { toCreasedNormals } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export default function creaseGeometryNormalsByMeshNameList(
  obj: Object3D,
  meshNameList: Array<string>
): void {
  obj.traverse((obj) => {
    if (obj instanceof Mesh && meshNameList.includes(obj.name)) {
      obj.geometry = toCreasedNormals(obj.geometry)
    }
  })
}
